import React from 'react';
import UploadSection from 'sub_components/Common/UploadSection';
const CDN_URL = process.env.REACT_APP_CDN_URL;

const EditIconDefault = `${CDN_URL}common/icon-edit-default-lg.svg`;
const EditIconHover = `${CDN_URL}common/icons-edit-selected-lg.svg`;

const emailSelected = `${CDN_URL}common/email-icon-selected-lg.svg`;
const phoneSelected = `${CDN_URL}common/phone-mobile-icon-selected-lg.svg`;
const UploadImageForm = `${CDN_URL}support/ticketing/attachment-icon-form-selected-lg.svg`;

function getIcon(type, contactSelected) {
	if (type === 'contact') {
		return contactSelected === 'email' ? emailSelected : phoneSelected;
	} else {
		return UploadImageForm;
	}
}
function formatNumber(number) {
	return number.replace('(', '').replace(')', '.').replace(' ', '').replace('-', '.');
}

const EditSectionSmall = ({ data, title, type, edit, auth_status, updateData }) => {
	const contactSelected = data.contact.preference;
	const contactDetails = data.contact.data;
	const { attachments } = data.issue;

	return (
		<div className='edit-section-wrapper'>
			<div className='edit-section-header'>
				<div className='type-icon'>
					<img src={getIcon(type, contactSelected)} />
				</div>
				<div className='title heading70'>{title}</div>
				{type !== 'issue' && (
					<div
						className='image'
						onClick={() => {
							edit(type);
						}}
					>
						<img
							src={EditIconDefault}
							onMouseOver={e => {
								e.currentTarget.src = EditIconHover;
							}}
							onMouseOut={e => {
								e.currentTarget.src = EditIconDefault;
							}}
						/>
					</div>
				)}
			</div>
			{type === 'contact' && (
				<div className='edit-section-body'>
					<div className='contact-title heading90'>{contactSelected}</div>
					<div className='contact-details body10'>
						{contactSelected === 'email' ? contactDetails : formatNumber(contactDetails)}
					</div>
				</div>
			)}

			{type === 'issue' && (
				<div className='edit-section-body'>
					<UploadSection
						attachments={attachments}
						auth_status={auth_status}
						updateData={updateData}
						phase='edit'
					/>
				</div>
			)}
		</div>
	);
};

export default EditSectionSmall;
